import localforage from 'localforage';

const config = {
    name: 'spate-app',
    version: 1,
};

export const cachedFetchStore = localforage.createInstance({
    ...config,
    storeName: 'cachedFetch',
});

export const flushCacheAndHardReload = async () => {
    try {
        return await cachedFetchStore.clear();
    } finally {
        window.location.reload();
    }
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        // something
    }
};
